import { useMutation } from "react-query";

import axios, { AxiosError } from "axios";

import { PAD_SCENARIO_SERVICE_ADDRESS } from "../../../constants/app.constants";

const API_URL = `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/data-input/excel-template`;

export interface FetchExcelTemplateRequest {
  fields: string[];
  scenarioId: string;
}

export interface FetchExcelTemplateResponse {
  // The response will be a blob (Excel file)
  data: Blob;
  filename?: string;
}

const fetchExcelTemplate = async (
  request: FetchExcelTemplateRequest
): Promise<FetchExcelTemplateResponse> => {
  const response = await axios.post<Blob>(
    API_URL,
    {
      fields: request.fields,
      scenarioId: request.scenarioId
    },
    {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json"
      }
    }
  );

  // Extract filename from Content-Disposition header if available
  const contentDisposition = response.headers["content-disposition"];
  let filename = "stick_data_input_template.xlsx";

  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(
      /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    );
    if (filenameMatch && filenameMatch[1]) {
      filename = filenameMatch[1].replace(/['"]/g, "");
    }
  }

  return {
    data: response.data,
    filename
  };
};

export const useFetchExcelTemplate = () => {
  return useMutation<FetchExcelTemplateResponse, AxiosError, FetchExcelTemplateRequest>(
    fetchExcelTemplate,
    {
      onSuccess: (data) => {
        // Automatically trigger download when successful
        const url = window.URL.createObjectURL(data.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", data.filename || "excel_template.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    }
  );
};
